class RingtoneService {
  constructor() {
    this.audio = null;
    this.isPlaying = false;
    this.currentCallId = null;
  }

  // Create a simple ringtone using Web Audio API
  createRingtone() {
    if (this.audio) {
      return this.audio;
    }

    try {
      // Create audio context
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();

      // Create oscillator for the ringtone
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      // Connect nodes
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Configure the ringtone with slight modifications
      oscillator.frequency.setValueAtTime(800, audioContext.currentTime); // 800Hz tone
      oscillator.type = 'sine';

      // Create a longer, smoother pulsing effect (ring pattern)
      const currentTime = audioContext.currentTime;

      // First ring - longer and smoother
      gainNode.gain.setValueAtTime(0, currentTime);
      gainNode.gain.linearRampToValueAtTime(0.25, currentTime + 0.15); // Slower fade in
      gainNode.gain.linearRampToValueAtTime(0, currentTime + 0.6); // Longer ring

      // Pause
      gainNode.gain.setValueAtTime(0, currentTime + 0.6);

      // Second ring - longer and smoother
      gainNode.gain.linearRampToValueAtTime(0.25, currentTime + 0.8); // Slower fade in
      gainNode.gain.linearRampToValueAtTime(0, currentTime + 1.25); // Longer ring

      // Longer pause
      gainNode.gain.setValueAtTime(0, currentTime + 1.25);

      // Start the oscillator
      oscillator.start(currentTime);
      oscillator.stop(currentTime + 1.25);

      return {
        audioContext,
        oscillator,
        gainNode,
      };
    } catch (error) {
      return null;
    }
  }

  // Play ringtone for a specific call
  playRingtone(callId) {
    if (this.isPlaying && this.currentCallId === callId) {
      return; // Already playing for this call
    }

    this.stopRingtone(); // Stop any existing ringtone
    this.currentCallId = callId;
    this.isPlaying = true;

    const playRing = () => {
      if (!this.isPlaying || this.currentCallId !== callId) {
        return; // Stop if call ended
      }

      const ringtone = this.createRingtone();
      if (ringtone) {
        // Schedule next ring after current one ends
        setTimeout(() => {
          if (this.isPlaying && this.currentCallId === callId) {
            playRing();
          }
        }, 1500); // 1.5 second pause between rings (matches longer duration)
      }
    };

    // Start the first ring
    playRing();
  }

  // Stop ringtone
  stopRingtone() {
    this.isPlaying = false;
    this.currentCallId = null;
  }

  // Stop ringtone for a specific call
  stopRingtoneForCall(callId) {
    if (this.currentCallId === callId) {
      this.stopRingtone();
    }
  }
}

// Create a singleton instance
const ringtoneService = new RingtoneService();

export default ringtoneService;
